
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mining/[id]",
      function () {
        return require("private-next-pages/mining/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mining/[id]"])
      });
    }
  